import { getApiBaseUrl } from '../config/api';

/**
 * Join The League waitlist via the API (same fetch pattern as Payment.js).
 */
export async function joinLeagueWaitlist(email) {
  const baseUrl = getApiBaseUrl();
  if (!baseUrl) {
    throw new Error('API base URL is not configured');
  }

  const cleanBaseUrl = baseUrl.replace(/\/$/, '');
  const url = `${cleanBaseUrl}/league/waitlist`;

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email }),
  });

  if (!response.ok) {
    throw new Error('Failed to join waitlist');
  }

  return response.json();
}
